module.exports = __webpack_public_path__ + "static/img/logo_02.93786ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_02.png
// module id = 1Atw
// module chunks = 1